import { Observable } from 'rxjs/Observable';
import { Component, OnInit, ViewChild, ChangeDetectorRef, AfterViewInit, OnDestroy, Input } from '@angular/core';
import { CrudService, Search, MessageService, SharedDataService, SortDirection } from 'elbuild-ui-lib-core';
import { Company, Employee, User, UserType } from 'toolbandi-ui-lib';
import { TranslateService } from '@ngx-translate/core';
import { Router, ActivatedRoute } from '@angular/router';
import { forkJoin, combineLatest, Subscription } from 'rxjs';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { EmployeePersonalEditComponent } from '../employee-personal-edit/employee-personal-edit.component';
import { DialogService, ListFiltersComponent } from 'elbuild-ui-componentslib';

@Component({
	selector: 'app-employee-list',
	templateUrl: './employee-list.component.html',
	styleUrls: ['./employee-list.component.scss']
})
export class EmployeeListComponent implements OnInit, AfterViewInit, OnDestroy {
	loggedUser: User;

	loading: boolean = false;
	rows: Employee[];

	advancedSearch: Search = new Search('employee join company on employee.companyid = company.id', `concat(employee.fname,'',employee.lname)`, 'employee');

	@ViewChild('listfilters', {}) listfilters: ListFiltersComponent;
	showAdvancedSearch: boolean = true;

	@Input()
	companyid: number;
	subcription: Subscription;
	routeSubcription: Subscription;

	constructor(private crudService: CrudService<Employee>,
		private messageService: MessageService,
		private translateService: TranslateService,
		private dialogService: DialogService,
		private router: Router,
		private cdr: ChangeDetectorRef,
		private modalService: NgbModal,
		private sharedDataService: SharedDataService,
		private activatedRoute: ActivatedRoute) {
		this.advancedSearch.setSortDirection(SortDirection.ASCENDING);
		this.advancedSearch.setSortField('id');


	}

	ngAfterViewInit() {
		const urlparamsreq = this.listfilters.readParams();

		const requests: Observable<any>[] = [urlparamsreq];

		if (!this.loggedUser) {
			const userrequest = this.sharedDataService.currentLoggedUser;
			requests.push(userrequest);
		}

		this.subcription = combineLatest(requests).subscribe(data => {

			if (data[1]) {
				this.loggedUser = data[1];
			}
			if (this.loggedUser.utype === UserType.company) {
				this.companyid = this.loggedUser.companyid;
			}
			this.search(data[0]);

		});
	}

	ngOnInit() {



	}

	ngOnDestroy() {
		if (this.subcription) {
			this.subcription.unsubscribe();
		}

	}


	load() {
		this.loading = true;
		this.rows = [];
		this.cdr.detectChanges();

		if (this.companyid) {
			this.advancedSearch.addSimpleFilter('companyid', this.companyid);
		}

		const datarequest = this.crudService.searchEntities(Employee, 'employee', this.advancedSearch, this.advancedSearch.page);
		const countrequest = this.crudService.countEntities(Employee, 'employee', this.advancedSearch);

		forkJoin([datarequest, countrequest]).subscribe((results: any) => {
			this.advancedSearch.page.setTotal(results[1].ct);
			this.rows = results[0];
			this.loading = false;
		}, ({ error }) => {
			this.messageService.sendError(error, this.translateService.instant('labels.error-occurred'));
			this.loading = false;
		});
	}


	onPageChange(pageInfo: any) {

		this.advancedSearch.page.setPageNumber(pageInfo.offset);
		this.listfilters.addQueryParams();
		this.load();
	}

	onSortChange(sortInfo: any) {
		const sort = sortInfo.sorts[0];
		this.advancedSearch.setSortField(sort.prop);
		this.advancedSearch.setSortDirection(sort.dir);
		this.listfilters.addQueryParams();
		this.load();
	}

	onActivate(event: any) {
		if (true /*this.aclService.hasPermission('centri.detail')*/) {
			if (event.type === 'dblclick') {
				this.router.navigate([`/company/employee/view/${event.row.id}`], { queryParamsHandling: 'merge' });
			}
		}
	}


	search(searchParams?: any) {
		if (searchParams) {
			this.advancedSearch = searchParams;
		}
		this.load();
	}

	rowClass = (row: any) => {
		return '';
	}

	get page() {
		if (this.advancedSearch) {
			return this.advancedSearch.page;
		} else {
			return undefined;
		}
	}

	delete(row: Employee, event: any) {
		this.dialogService.openConfirmModal({
			message: this.translateService.instant('labels.warning-employee-delete'),
			hasIcon: true,
			type: 'warning'
		}).then(result => {
			if (result) {
				this.crudService.deleteEntity(Employee, 'employee', row).subscribe(() => {
					this.translateService.get(['labels.employee-deleted', 'labels.employees']).subscribe(messages => {
						this.messageService.sendSuccess(messages['labels.employee-deleted'], messages['labels.employees']);
						this.load();
					});
				});
			}
		});
	}


	edit(empoyeeid?: number) {
		const modal = this.modalService.open(EmployeePersonalEditComponent, {
			centered: true,
			size: 'lg',
			backdrop: 'static',
			keyboard: false
		});

		modal.componentInstance.companyid = this.companyid;

		if (empoyeeid) {
			modal.componentInstance.load(empoyeeid);
		}
		modal.result.then((newItem: Employee) => {
			this.load();
		}).catch(() => { });
	}

}
